export const checkIfCommandInProgress = (progress) => progress !== undefined ? progress !== '' : false
